import { IllinoisPurchaseTaxes } from '..'

export const PurchaseTaxes = { ...IllinoisPurchaseTaxes }
